// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.hidden[data-v-2bb96046] {\n  display: none;\n}\n.pageAlign[data-v-2bb96046] {\n  float: right;\n}\n\n", ""]);
// Exports
module.exports = exports;
